<template>
  <div id="statisticalArea">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'statisticalArea'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/statistical/exhibition/area/StatisArea.vue